module.exports = __webpack_public_path__ + "img/ic_die_bl.462c93a2.svg";